$(function() {
    $('.checkedServiceOffering .checkboxLabel input').change(function () {
        var confirmUrl = $(this).closest(".checkedServiceOffering").attr("data-confirmLink");
        var target = $(".linkBox a",$(this).closest(".checkedServiceOffering") );
        var hint = $(this).closest(".checkedServiceOffering").find(".hint");
        var ctaLink = $(this).closest(".checkedServiceOffering").attr("data-CTALink");
        if(this.checked){
            $.ajax({
                url: confirmUrl
            }).done(function(data) {
                hint.remove();
                target.attr("href", data.trim());
                $('.checkedServiceOffering .checkmark').css('border','1px solid #1E325F');
            });
        }else{
            target.attr("href","");
        }
    });
    $('.checkedServiceOffering .linkBox a').click(function (e) {
        if( $(this).attr('href') == undefined || $(this).attr('href') == '' ){
            e.preventDefault();
            e.stopPropagation();
            if( !($(this).closest(".checkedServiceOffering").find(".hint").length) ){
                $(this).closest(".checkedServiceOffering").find('.checkboxContainer').append('<div class="hint">'+$(this).closest(".checkedServiceOffering").find(".linkBox").attr('data-message')+'</div>');
                $(this).closest(".checkedServiceOffering").find('.checkmark').css('border','1px solid #FF0000');
            }
        }
    });
});
